import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TnrAuthProviderService } from '@tnr/ng-oauth2';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  template: `
    <div class="h-100 mh-100 d-flex flex-column justify-content-center align-items-center">
      <p class="text-lg text-gray-600 m-0">Loading identity provider...</p>
    </div>
  `
})
export class LoginComponent implements OnInit {
  constructor(
    private readonly authProviderService: TnrAuthProviderService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const isTnrAuthed = await firstValueFrom(this.authProviderService.isAuthenticated$);
    if (isTnrAuthed) {
      const token = await this.authService.refreshCoLabSession();
      if (token) {
        this.router.navigate(['/']);
      } else {
        this.authProviderService.login();
      }
    } else {
      this.authProviderService.login();
    }
  }
}
